import { Cart } from './modules/cart.js';
import { Header } from './modules/header.js';
import { ScrollHandler } from './modules/scroll.js';
import { ReadMore } from './modules/readmore.js';
import { PseudoSelect } from './modules/pseudoselect.js';
import { ContextMenus } from './modules/contextmenus.js';
import { LeavesActivator } from './modules/leaves.js';
import { initCarousel } from './modules/carousel.js';
import { StateManager } from './utils/stateManager.js';
import { initTagFilterCounts } from './modules/tag-filter-counts.js';
import { initTagFilterPreview } from './modules/tag-filter-preview.js';
import { ImageModal } from './modules/image-modal.js';

class App {
  constructor(options) {
    this.defaults = {
      defaultK: false,
    };
    this.options = {};
    this.globalState = null;
    this.baseQueryEl = document;
    Object.assign(this.options, this.defaults, options);
    this.stateManager = new StateManager();

    this.namespace = 'App';
    this.init();
  }

  init() {
    this.initHeader();
    this.initScroll();
    this.initPseudoSelects();
    window.addEventListener('load', () => {
      this.initReadMore();
      this.initContextMenus();
      this.initDynamicCounts();
      this.initDynamicCart();
      this.initIllustration();
      this.initPrivacyPolicy();
      this.initTagFilters();
      initTagFilterPreview();
      // if .product__media img exists, init image modal
      const productMedia = this.baseQueryEl.querySelector('.product__media');
      if (productMedia) {
        const images = productMedia.querySelectorAll('img');
        if (images.length > 0) {
          const imageModal = new ImageModal();
          imageModal.init();
        }
      }
    });

    document.addEventListener('reinitContextMenus', () => {
      this.initContextMenus();
      initTagFilterPreview();
    });
  }

  initDynamicCart() {
    this.cart = new Cart(this.baseQueryEl, this.stateManager);
    this.cart.bindEvents();
  }

  initScroll() {
    this.scrollHandler = new ScrollHandler({ threshold: 50, hiddenClass: 'header--hidden' });
    this.scrollHandler.init();
  }

  initCB(targetEl) {
    if (targetEl) {
      this.baseQueryEl = targetEl;

      this.initReadMore();
    }
  }

  initHeader() {
    this.globalState = null;
    this.header = new Header(this.baseQueryEl, this.stateManager);
    this.header.init();
  }

  initReadMore() {
    this.readMore = new ReadMore(this.baseQueryEl);
    this.readMore.init();
  }

  initContextMenus() {
    this.contextMenus = new ContextMenus(this.baseQueryEl, this.stateManager);
    this.contextMenus.init();
  }

  initDynamicCounts() {
    const elements = this.baseQueryEl.querySelectorAll('.dynamic-get-item-count');
    if (elements.length === 0) return;

    const countElement = document.querySelector('#resultcount');
    if (!countElement) return;

    const count = parseInt(countElement.textContent.trim(), 10);
    if (isNaN(count)) return;

    elements.forEach((element) => {
      element.textContent = count === 1 ? `Show ${count} item` : `Show ${count} items`;
    });
  }

  initPseudoSelects() {
    this.pseudoSelect = new PseudoSelect(this.baseQueryEl);
    this.pseudoSelect.init();
  }

  initIllustration() {
    const illustration = this.baseQueryEl.querySelector('.stout__illustration');
    if (!illustration) return;

    const doorOverlay = this.baseQueryEl.querySelector('.door__overlay');
    if (doorOverlay) {
      if (doorOverlay.classList.contains('door__overlay--responsive')) {
        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        const currentHour = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();
        const currentDay = currentTime.getDay();

        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const currentDayName = dayNames[currentDay];
        const openHoursKey = `open_hours_${currentDayName}`;
        const closeHoursKey = `close_hours_${currentDayName}`;

        if (
          window[openHoursKey] &&
          window[closeHoursKey] &&
          window[openHoursKey] !== '' &&
          window[closeHoursKey] !== '' &&
          window[openHoursKey] !== 'CLOSED' &&
          window[closeHoursKey] !== 'CLOSED'
        ) {
          const openHours = window[openHoursKey].split(':');
          const closeHours = window[closeHoursKey].split(':');
          const openTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
          const closeTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
          openTime.setHours(openHours[0]);
          openTime.setMinutes(openHours[1]);
          closeTime.setHours(closeHours[0]);
          closeTime.setMinutes(closeHours[1]);
          if (currentTime >= openTime && currentTime < closeTime) {
            doorOverlay.classList.add('door__overlay--active');
          }
        }
      }
    }

    this.initHomeLeaves();
  }

  initHomeLeaves() {
    this.leavesActivator = new LeavesActivator(this.baseQueryEl);
    this.leavesActivator.init();
  }

  initPrivacyPolicy() {
    const privacyMessage = document.getElementById('privacy-message');
    const dismissed = localStorage.getItem('privacyDismissed');

    if (!dismissed) {
      privacyMessage.classList.remove('hidden');
    }

    document.querySelector('.privacy-message__close').addEventListener('click', function () {
      localStorage.setItem('privacyDismissed', 'true');
      privacyMessage.classList.add('hidden');
    });
  }

  initTagFilters() {
    initTagFilterCounts({
      filterContainerSelector: '.tag-filters__list',
      countEndpointView: 'count', // or whatever view returns only the count <p>
    });
  }
}

const app = new App();

document.addEventListener('DOMContentLoaded', function () {
  var autoloadButton = document.querySelector('.autoload__new-arrivals');
  if (autoloadButton) {
    var currentCollection = autoloadButton.getAttribute('data-currentcollection');
    var url = '/collections/' + currentCollection + '/new-arrivals';
    if (!currentCollection || currentCollection === '') {
      return;
    }
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var productGrid = doc.querySelector('#product-grid');
        if (productGrid) {
          var collectionEmpty = productGrid.classList.contains('collection--empty');
          if (collectionEmpty) {
            // autoloadButton.remove();

            // hide the section if there aren't any New Arrivals
            // add a class to document.querySelector('.section__autoload-wrapper') parent
            document.querySelector('.section__autoload-wrapper').parentElement.classList.add('autosection--hidden');
            document.querySelector('.section__autoload-wrapper').remove();
          } else {
            var productGridContents = productGrid.innerHTML;
            autoloadButton.innerHTML = productGridContents;
            initCarousel('.carousel__parent'); // call this only after autoload content has been inserted into the DOM
          }
        }
      });
  }

  document.querySelectorAll('.collection-toggle').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const newCollection = toggle.getAttribute('data-handle');
      if (!newCollection || newCollection === '') return;

      const url = '/collections/' + newCollection;
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          const productGrid = doc.querySelector('#product-grid');
          if (productGrid) {
            const collectionEmpty = productGrid.classList.contains('collection--empty');
            if (collectionEmpty) {
              document.querySelector('.section__autoload-wrapper').parentElement.classList.add('autosection--hidden');
              document.querySelector('.section__autoload-wrapper').remove();
            } else {
              const autoloadButton = document.querySelector('#product__seemore');
              if (autoloadButton) {
                if (autoloadButton.querySelector('article')) {
                  autoloadButton.querySelectorAll('article').forEach((el) => el.remove());
                }
                autoloadButton.insertAdjacentHTML('afterbegin', productGrid.innerHTML);

                const currentURL = window.location.href;
                if (autoloadButton.querySelector('article')) {
                  autoloadButton.querySelectorAll('article').forEach((el) => {
                    const productLink = el.querySelector('a');
                    if (productLink) {
                      const productHref = productLink.getAttribute('href');
                      // if (productHref && !productHref.startsWith('http')) {
                      //   productLink.setAttribute('href', currentURL + productHref);
                      // }
                      if (productHref && currentURL.includes(productHref)) {
                        el.remove();
                      }
                    }
                  });
                }

                initCarousel('.carousel__parent');
              }
            }
          }
        });

      // Update active class
      document.querySelectorAll('.collection-toggle').forEach((el) => el.classList.remove('active'));
      toggle.classList.add('active');
    });
  });

  const carouselParents = document.querySelectorAll('.section__w-carousel');
  if (carouselParents.length === 0) return;
  carouselParents.forEach((carouselParent) => {
    const carousel = carouselParent.querySelector('.carousel__parent');
    if (!carousel) return;
    initCarousel('.section__w-carousel .carousel__parent');
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('app-embed');
    if (!form) return;

    const shadow = form.shadowRoot;
    if (!shadow) return; // in case of closed shadow DOM

    observer.disconnect();

    const css = `
      input, button[aria-expanded], textarea {
        border-radius: 0 !important;
        border: none !important;
      }

      --form-field-border-radius: 0 !important;
    `;

    try {
      if ('adoptedStyleSheets' in Document.prototype) {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
      } else {
        const styleTag = document.createElement('style');
        styleTag.textContent = css;
        shadow.appendChild(styleTag);
      }
    } catch (e) {
      // fallback in case something fails
      const styleTag = document.createElement('style');
      styleTag.textContent = css;
      shadow.appendChild(styleTag);
    }

    formContainer.classList.add('loaded');
  });

  observer.observe(document.body, { childList: true, subtree: true });
});